<template>
    <div id="app">
        <v-app id="inspire">
            <v-main>
                <v-container fill-height fluid>
                    <v-layout align-center justify-center>
                        <v-flex md4 sm8 xs12>

                            <v-img
                                    :src="require('@/assets/logo_clk.png')"
                                    class="my-3"
                                    contain
                                    height="200"
                            ></v-img>

                            <v-card class="elevation-12">
                                <v-toolbar color="primary" dark>
                                    <v-toolbar-title>Login</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-card-text>
                                    <v-form @submit.prevent="login" id="login-form">
                                        <v-text-field id="email" label="Login" name="login" prepend-icon="person"
                                                      type="text" v-model="email"></v-text-field>
                                        <v-text-field id="password" label="Password" name="password" prepend-icon="lock"
                                                      type="password" v-model="password"></v-text-field>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn @click.stop="dialog = true" color="primary">Passwort vergessen?
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="login" color="primary" form="login-form" type='submit'>Login</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-dialog
                        v-model="dialog"
                        width="600"
                >
                    <v-card>
                        <v-card-title
                                class="headline grey lighten-2"
                                primary-title
                        >
                            Passwort vergessen
                        </v-card-title>

                        <v-card-text>
                            Bitte geben sie ihre Email ein.
                        </v-card-text>

                        <v-text-field class="ml-3 mr-3"
                                      id="forgot-email" label="Email" name="email"
                                      type="text" v-model="email"></v-text-field>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    @click="dialog = false"
                                    color="primary"
                            >
                                Abbrechen
                            </v-btn>
                            <v-btn
                                    @click="forgotPW"
                                    color="primary"
                            >Okay
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-main>
        </v-app>
    </div>
</template>

<script>
    import Authentication from "../API/Authentication";
    import User from "../API/User";

    import LoginStore from '@/ts/stores/LoginStore'
    import ErrorStore from "@/ts/stores/ErrorStore";

    export default {
        name: "Login",

        data() {
            return {
                validation: true,
                email: '',
                password: '',
                dialog: false,

                snackbar: false,
                snackbarText: "",
                snackbarTimeout: 2500
            }
        },
        watch: {
            dialog() {
                const handler = e => {
                    if (e.keyCode === 27) {
                        this.dialog = false;
                        window.removeEventListener('keydown', handler)
                    }
                };
                if (this.dialog) {
                    window.addEventListener('keydown', handler)
                }
            }
        },
        methods: {
            forgotPW() {
                User.forgotPW(this.email).then(res => {
                    this.dialog = false;
                    this.snackbar = true;
                    this.snackbarText = "Email mit Wiederherstellungslink wurde versendet."
                }).catch(err => {
                    this.dialog = false;
                    this.snackbar = true;
                    this.snackbarText = "Fehler beim versenden der Email."
                })
            },
            login() {
                this.validation = true;
                Authentication.login(this.email, this.password).then(res => {
                    if (res.auth_token.length > 0 && res.user.roles[0] === "super_admin") {
                        LoginStore.state.authToken = res.auth_token;
                        this.$router.push("/mandates")
                    } else {
                        ErrorStore.showError("Sie haben einen ungültigen Login eingegeben oder sind nicht berechtigt diese Oberfläche zu operieren.");
                        this.validation = false
                    }
                }).catch(err => {
                    ErrorStore.showError("Sie haben einen ungültigen Login eingegeben oder sind nicht berechtigt diese Oberfläche zu operieren.");
                    this.validation = false;
                })
            }
        }
    }
</script>

<style lang="scss">

</style>
